import { compose } from 'recompose';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';

import {
  cannotMoveToOtherStep,
  closeErrorWindow,
  submitDecisionSplitForm,
  translateOutcomes,
  updateDoneButton,
} from '../../actions/JourneyBuilder';
import { checkIsDisabledDoneBtn, getIsLoading } from '../../reducers/JourneyBuilder';
import { JOURNEY_BUILDER_FORM_NAME } from '../../constants/JourneyBuilder';
import JourneyBuilderDecisionSplitFormComponent from './JourneyBuilderDecisionSplitFormComponent';

const JourneyBuilderDecisionSplitFormContainer = reduxForm({
  form: JOURNEY_BUILDER_FORM_NAME,
  enableReinitialize: true,
})(JourneyBuilderDecisionSplitFormComponent);

export default compose(
  connect(
    ({ journeyBuilderArea: { JourneyBuilderSettings } }) => ({
      ...JourneyBuilderSettings,
      isLoading: getIsLoading(JourneyBuilderSettings),
      isDisabledDoneBtn: checkIsDisabledDoneBtn(JourneyBuilderSettings),
      initialValues: JourneyBuilderSettings.JourneyBuilder,
      errorMessage: JourneyBuilderSettings.error,
      topicName: JourneyBuilderSettings.topicName,
      journeyHasMetadata: JourneyBuilderSettings.journeyHasMetadata,
    }),
    {
      onSubmitFail: cannotMoveToOtherStep,
      onSubmit: submitDecisionSplitForm,
      translateOutcomes,
      updateDoneButton,
      closeErrorWindow,
    }
  )
)(JourneyBuilderDecisionSplitFormContainer);



// WEBPACK FOOTER //
// ./src/JourneyBuilder/DecisionSplit/components/JourneyBuilderDecisionSplitFormContainer.js